<h2 mat-dialog-title>{{ data.modalTitle }}</h2>
<mat-dialog-content class="table-dialog">
  <glxy-table-container
    [columns]="columns$ | async"
    [dataSource]="dataSource"
    [pageSizeOptions]="pageSizeOptions"
    [pageSize]="pageSize"
    [showSelection]="true"
    [singleSelection]="data.singleSelection || false"
    (selectionChanged)="selectionChanged($event)"
    [fullWidth]="true"
  >
    <glxy-table-content-header
      [showSort]="false"
      [showActions]="data.showActions || false"
      [showFilters]="true"
      [showFiltersOpen]="false"
      [showColumnArrange]="(isMobile$ | async) === false"
      [showFiltersApplied]="(showFiltersApplied$ | async) ?? false"
      [hideActionButton]="data.hideActionButton || false"
      [selectAllAvailable]="(hasSelectAllActions$ | async) ?? false"
      (selectAllToggled)="handleSelectAll()"
      (selectionCleared)="dataSource.clearSelectionOnly()"
    >
      <glxy-filter-chips
        [addFiltersHeader]="'TABLE_FILTERS.HEADER' | translateForCrmObject: objectType | async"
        (filtersChanged)="updateFilters($event)"
        filters-area
      ></glxy-filter-chips>
    </glxy-table-content-header>
    <!-- [hidden] is used here to hide the table columns until the table has finished loading data for the first time -->
    <table mat-table [hidden]="initialLoadingCompleted$ | async">
      <tr mat-header-row *matHeaderRowDef="[]"></tr>
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          @if (!data.singleSelection) {
            <glxy-table-selection></glxy-table-selection>
          }
        </th>
        <td mat-cell *matCellDef="let row">
          <glxy-table-selection
            [row]="row"
            [preSelectedLockedRows]="preSelectedLockedRows"
            [preSelectedRows]="newSelection"
          ></glxy-table-selection>
        </td>
      </ng-container>
      <tr mat-row *matRowDef="let row; columns: []" [attr.data-testid]="'crm-object-row-' + row.id"></tr>
    </table>
    @if (showEmptyState$ | async) {
      <glxy-empty-state class="empty-table-container" data-testid="crm-objects-table-empty-state">
        <glxy-empty-state-hero>
          <img
            class="empty-state-image"
            src="https://storage.googleapis.com/galaxy-libs-public-images/crm/contacts-empty-state.svg"
            [alt]="'LIST_OBJECTS_TABLE.EMPTY_TABLE.IMAGE_ALT' | translateForCrmObject: objectType | async"
          />
        </glxy-empty-state-hero>
        <glxy-empty-state-title>
          {{ 'LIST_OBJECTS_TABLE.EMPTY_TABLE.HEADER' | translateForCrmObject: objectType | async }}
        </glxy-empty-state-title>
        <p>{{ 'LIST_OBJECTS_TABLE.EMPTY_TABLE.HINT' | translateForCrmObject: objectType | async }}</p>
      </glxy-empty-state>
    }
  </glxy-table-container>
</mat-dialog-content>
<mat-dialog-actions>
  @if (showCreateButton) {
    <div class="dialog-secondary-actions">
      <button mat-button color="primary" (click)="createObjectModal()">
        @if (createButtonText) {
          {{ createButtonText }}
        } @else {
          {{ 'SELECT_MODAL.CREATE_NEW' | translateForCrmObject: objectType | async }}
        }
      </button>
    </div>
  }
  <button mat-stroked-button (click)="cancel()">
    {{ 'ACTIONS.CANCEL' | translate }}
  </button>

  <button mat-flat-button color="primary" (click)="save()">
    @switch (numSelected()) {
      @case (0) {
        {{ 'ACTIONS.ADD' | translate }}
      }
      @case (1) {
        {{ 'SELECT_MODAL.ONE_SELECTED' | translateForCrmObject: objectType | async }}
      }
      @default {
        @if (dataSource.state.selectAll) {
          <div>
            {{
              'SELECT_MODAL.MORE_SELECTED'
                | translateForCrmObject: objectType : { totalSelected: dataSource.state.totalDataMembers }
                | async
            }}
          </div>
        } @else {
          <div>
            {{
              'SELECT_MODAL.MORE_SELECTED'
                | translateForCrmObject: objectType : { totalSelected: numSelected() }
                | async
            }}
          </div>
        }
      }
    }
  </button>
</mat-dialog-actions>